/**
 * Dragging the time axis zooms with the right edge of the pane in place:
 * right makes bars wider, left narrower (as in TradingView / lightweight-charts).
 *
 * @param {object} view - see createInteraction
 * @param {{ x: number, y: number }} point - where the drag started, CSS px
 * @returns {{ move: Function, end: Function }}
 */
export const createTimeAxisDrag = (view, point) => {
  const { timeScale } = view;
  const { width } = timeScale;
  const startSpacing = timeScale.barSpacing;
  const startFromRight = Math.max(1, width - point.x);

  return {
    move: (nextPoint) => {
      const fromRight = Math.max(1, width - nextPoint.x);

      timeScale.zoomAt(width, (startSpacing * startFromRight) / fromRight);
      view.invalidate();
    },
    end: () => {},
  };
};
